
import http from '@/api/ajax.js' //ajax请求
const state = {
  noticeNum:''
}

const mutations = {
  SET_NOTICENUM: (state, noticeNum) => {
    state.noticeNum = noticeNum;
    sessionStorage.noticeNum = noticeNum;
  },
}

const actions = {
  // 未读公告数量
  async getNoticeNum({ commit,state }){
    if(state.noticeNum){
      return;
    }
    const res = await http({
      url:'/master/mechanIndex/queryFirstTypeUnRead',
      type:'put',
      params: {}
    })
    let sum = 0;
    res.data.forEach(item1=>{
      if(item1.firstType==2||item1.firstType==3) {
        sum+=item1.count*1;
      }
    })
    commit('SET_NOTICENUM', sum);
  },
}
export default {
  namespaced: false,
  state,
  mutations,
  actions
}
